import { FaBars } from "react-icons/fa";
import { useContext, useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import { IoIosArrowDown, IoIosArrowForward, IoIosArrowUp } from "react-icons/io";
import { MdLogout } from "react-icons/md";
import { IoIosHelpCircle } from "react-icons/io";
import { HiUsers } from "react-icons/hi";
import { CgProfile } from "react-icons/cg";

import { msalInstance } from '../msal/msal';
import { AppContext } from "../context/AppContext";

const Topbar = ({ isSidebarOpen, setIsSidebarOpen }) => {
  // const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isRolesOpen, setIsRolesOpen] = useState(false);
  const { roles, setToast } = useContext(AppContext);
const {isDropdownOpen, setIsDropdownOpen}=useContext(AppContext)

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const toggleRoles = () => {
    setIsRolesOpen(!isRolesOpen);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    window.location.href = "/login";
  };

  const clearSession = () => { 
    // Clear local storage and session storage
    localStorage.clear();
    sessionStorage.clear();

    // Clear cookies
    document.cookie.split(";").forEach((cookie) => {
      const name = cookie.split("=")[0].trim();
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
    });

    console.log("Session cleared.");
  };

  const logout = async () => {
    try {
      // console.log("Logging out from the application...");
      const account = msalInstance.getAllAccounts()[0];
      if (account) {
        await msalInstance.logoutRedirect({
          postLogoutRedirectUri: process.env.REACT_APP_REDIRECT_URI || window.location.origin,
          account,
        });
        clearSession();
      }
    } catch (error) {
      console.error("Error during logout:", error);
    }
  };

  useEffect(() => {
    if (roles?.role_name?.length == 0) {
      logout().then(() => {
        setToast({ show: true, type: "error", message: "You do not have access to this application. Please contact the administrator for assistance." });
      })
    }
  },[roles?.role_name])
  return (
    <div className="flex h-[70px] px-3 py-4 bg-[#F8FAFC] border-b-2 border-gray-200">
      <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

      <div className="w-full flex items-center justify-between " onClick={()=>setIsDropdownOpen(false)}>
        <button onClick={toggleSidebar} className="text-gray-700">
          <FaBars size={15} />
        </button>

        <div className="relative flex items-center gap-1">
          <div className="flex-col ">
          <p className="font-bold text-gray-700 sm:text-[14px] text-[12px] ">{roles?.first_name}</p>
           {roles.role_name.map((item) =>
                    <p className="text-right font-semibold text-gray-600  rounded-md ">{item ? item : ""}</p>
                  )
                  }
          </div>
         
          {isDropdownOpen && (
            <div className="absolute  sm:text-[14px] text-[11px] bg-white top-6 mt-2 sm:w-[200px]  shadow-md rounded-lg  border border-gray-300 z-[9999] right-0">
              {/* <button
                onClick={toggleRoles}
                className="w-full cursor-default flex items-center justify-between py-2 px-4 text-gray-700 hover:bg-gray-100 rounded-md"
              > */}
                {/* <div className="flex items-center gap-2"> */}
                  {/* <HiUsers className="text-xl" /> */}
                  {/* <span>View Roles</span> */}
                {/* </div> */}
                {/* {isRolesOpen ? <IoIosArrowUp className="text-lg" /> : <IoIosArrowForward className="text-lg" />} */}
              {/* </button> */}


              {/* {isRolesOpen && ( */}
                {/* <div className="ml-4">
                  {roles.role_name.map((item) =>
                    <p className="px-8  text-gray-600  rounded-md ">{item ? item : ""}</p>
                  )
                  }

                </div> */}
              {/* )} */}

              <button
                className="flex items-center gap-2 w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-md cursor-not-allowed"
                // onClick={() => alert('View Profile clicked')}
                disabled={true}
              >
                <CgProfile className="text-xl" />
                View Profile
              </button>

              {/* <div className="flex items-center justify-start px-4 py-2"> */}
              <button
                className="flex items-center gap-2 w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-md"
                onClick={logout}
              >
                <MdLogout className="text-gray-700" size={20} />

                Logout
                {/* </div> */}
              </button>

              <button
                className="flex items-center gap-2 w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-md cursor-not-allowed"
                // onClick={() => alert('Help & Support clicked')}
                disabled={true}

              >
                <IoIosHelpCircle className="text-xl" />
                Help & Support
              </button>

              {/* <div className="border-t border-gray-300 mt-2"></div> */}

            </div>
          )}
        </div>
      </div>
      <span className="flex justify-center px-1 ">
       <button  className="text-gray-700 sm:text-2xl text-sm  ">
            <IoIosArrowDown onClick={toggleDropdown} className="cursor-pointer " />
          </button>

      </span>

    </div>
  );
};

export default Topbar;

 